import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_BILLS](state, data) {
    state.allBills = data
  },
}
